var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page403/LockIcon.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LockIcon = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "114",
  height: "150",
  viewBox: "0 0 114 150",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M99.75 50H92.625V35.7143C92.625 16 76.665 0 57 0C37.335 0 21.375 16 21.375 35.7143V50H14.25C6.4125 50 0 56.4286 0 64.2857V135.714C0 143.571 6.4125 150 14.25 150H99.75C107.588 150 114 143.571 114 135.714V64.2857C114 56.4286 107.588 50 99.75 50ZM35.625 35.7143C35.625 23.8571 45.1725 14.2857 57 14.2857C68.8275 14.2857 78.375 23.8571 78.375 35.7143V50H35.625V35.7143ZM99.75 132.714C99.75 134.371 98.4069 135.714 96.75 135.714H17.25C15.5931 135.714 14.25 134.371 14.25 132.714V67.2857C14.25 65.6289 15.5931 64.2857 17.25 64.2857H96.75C98.4069 64.2857 99.75 65.6289 99.75 67.2857V132.714ZM57 114.286C64.8375 114.286 71.25 107.857 71.25 100C71.25 92.1429 64.8375 85.7143 57 85.7143C49.1625 85.7143 42.75 92.1429 42.75 100C42.75 107.857 49.1625 114.286 57 114.286Z",
    fill: "#353B60"
  }), /*#__PURE__*/_jsx("path", {
    d: "M52 113C52 111.343 53.3431 110 55 110H59C60.6569 110 62 111.343 62 113V121C62 122.657 60.6569 124 59 124H55C53.3431 124 52 122.657 52 121V113Z",
    fill: "#353B60"
  })]
});